import { render, staticRenderFns } from "./CreateResources.vue?vue&type=template&id=0194f39c&scoped=true&"
import script from "./CreateResources.vue?vue&type=script&lang=js&"
export * from "./CreateResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194f39c",
  null
  
)

export default component.exports